<template>
<span class="cmp-margin-right">
    <!-- TODO: FontAwesome Pro 추가 후 주석 처리된 컴포넌트 사용 필요 -->
    <el-tooltip content="토폴로지맵" placement="top">
      <el-button class="tool-button topologymap" type="content" size="medium" @click="onTopologyMapButtonClick"/>
    </el-tooltip>
    <el-tooltip v-show="showPingButton" content="Ping" placement="top">
      <el-button class="tool-button ping" type="content" size="medium" @click="excuteLauncher('PING')"/>
    </el-tooltip>
    <el-tooltip v-show="showTerminalButton" content="터미널" placement="top">
      <el-button class="tool-button terminal" type="content" size="medium" @click="excuteLauncher('TERMINAL')"/>
    <!-- <el-button icon="far fa-terminal" size="medium"></el-button> -->
    </el-tooltip>
    <el-tooltip v-show="showTraceRouteButton" content="IP Scan" placement="top">
      <el-button class="tool-button trace-route" type="content" size="medium" @click="onIpScanButtonClick"/>
    <!-- <el-button icon="fas fa-route" size="medium"></el-button> -->
    </el-tooltip>
    <el-tooltip v-show="showWebLinkButton" content="MIB Browser" placement="top">
      <el-button class="tool-button web-link" type="content" size="medium" @click="onMibBrowserButtonClick"/>
    <!-- TODO: Ju 버튼 가이드에서 Ping과 동일한 아이콘으로 되어있음. UX팀에 확인 필요. 일단 임시로 link 버튼 배치-->
    </el-tooltip>
  </span>
</template>

<script>
import { isEmpty, isNil } from 'lodash';
import msgUtil from '@/utils/message';
import { applicationLauncher } from '@/utils/applauncher';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import appApi from '@/api/common/app';

export default {
  name: 'WManageToolButtonSet',
  props: {
    /* eslint-disable arrow-body-style */
    obj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /* eslint-enable arrow-body-style */
  },
  computed: {
    showPingButton() {
      const obj = this.obj;
      if (obj.objManagetypeId === 'VMS') {
        return obj.objtypeId === 'VHO' || obj.objtypeId === 'VVM';
      } else if (obj.objManagetypeId === 'NMS' && obj.objDefineId === 'WIRELESS_DEVICE') {
        return isNil(obj.parentObjId);
      }
      return obj.objManagetypeId !== 'SVC';
    },
    showTraceRouteButton() {
      const obj = this.obj;
      if (obj.objManagetypeId === 'VMS') {
        return obj.objtypeId === 'VHO' || obj.objtypeId === 'VVM';
      } else if (obj.objManagetypeId === 'NMS' && obj.objDefineId === 'WIRELESS_DEVICE') {
        return isNil(obj.parentObjId);
      }
      return obj.objManagetypeId !== 'SVC';
    },
    showWebLinkButton() {
      const obj = this.obj;
      if (obj.objManagetypeId === 'NMS' && obj.objDefineId === 'WIRELESS_DEVICE') {
        return isNil(obj.parentObjId);
      }
      return obj.objManagetypeId !== 'SVC';
    },
    showTerminalButton() {
      const obj = this.obj;
      if (obj.objManagetypeId === 'VMS') {
        return obj.objtypeId === 'VHO' || obj.objtypeId === 'VVM';
      } else if (obj.objManagetypeId === 'NMS' && obj.objDefineId === 'WIRELESS_DEVICE') {
        return isNil(obj.parentObjId);
      }
      return obj.objManagetypeId !== 'SVC';
    },
  },
  methods: {
    /**
     * 해당 장비의 첫 번째 토폴로지 맵으로 화면을 전환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    onTopologyMapButtonClick() {
      if (!isEmpty(this.obj)) {
        const objId = this.obj.objId;
        routePathByObjId(this, objId, menuDefine.TOPOLOGYMAP);
      } else {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장비의 정보', false));
      }
    },
    onIpScanButtonClick() {
      applicationLauncher().openIpScanPopup(this.obj.objId);
    },
    onMibBrowserButtonClick() {
      applicationLauncher().openMibBrowserPopup(this.obj.objId);
    },
    excuteLauncher(exectype) {
      let executeType = exectype;
      appApi.getAppExecuteInfo(this.obj.objId).then((response) => {
        if (response.data.success && !isEmpty(response.data.data)) {
          const obj = response.data.data;
          if (executeType === 'TERMINAL') {
            executeType = obj.useSSH ? 'SSH' : 'TELNET';
          }
          applicationLauncher().directExecute(executeType, obj, this);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/button/ManageToolButtonSet.vue